import type { Phase } from "@shared/types";

/**
 * Read-only window into the running game for end-to-end tests. Everything is
 * drawn on a canvas, so Playwright cannot query the DOM; instead the scene
 * publishes the phase and tap targets here. Only installed in mock mode.
 */
export type TapTarget = { x: number; y: number };

export type TestHooks = {
  phase: Phase;
  roundNumber: number;
  myUserId: string;
  promptText: string;
  players: Array<{ userId: string; hasVoted: boolean; connected: boolean; score: number } & TapTarget>;
  startButton: TapTarget | null;
  lastWinners: string[];
};

declare global {
  interface Window {
    oddsAreTest?: TestHooks;
  }
}

export function installTestHooks(): TestHooks | null {
  if (import.meta.env.VITE_DISCORD_MOCK !== "1") return null;
  const hooks: TestHooks = {
    phase: "lobby",
    roundNumber: 0,
    myUserId: "",
    promptText: "",
    players: [],
    startButton: null,
    lastWinners: [],
  };
  window.oddsAreTest = hooks;
  return hooks;
}
